import type { GroupProps } from '../types';

import { useMemo } from 'react';

interface GroupValues {
  views: number;
  conversions: number;
  variantID: string;
}

export function useGroup(initialProps: GroupProps) {
  const conversionRate = useMemo(() => {
    return initialProps.views !== 0 ? initialProps.conversions / initialProps.views : 0;
  }, [initialProps.views, initialProps.conversions]);

  const values = useMemo(
    (): GroupValues => ({
      views: initialProps.views,
      conversions: initialProps.conversions,
      variantID: initialProps.variantID,
    }),
    [initialProps.views, initialProps.conversions, initialProps.variantID],
  );

  return {
    getViews: () => initialProps.views,
    getConversions: () => initialProps.conversions,
    getConversionRate: () => conversionRate,
    getVariantID: () => initialProps.variantID,
    getValues: () => values,
  };
}

export type IGroupAdapter = ReturnType<typeof useGroup>;
